module.exports = __webpack_public_path__ + "static/media/receive.6e978e0a.gif";